// Copyright (c) 2023-present, Highway 9 Networks, Inc.

import { IDNN } from "~/types/dnn";
import APIService from "./APIServices";

const dnnAPI = new APIService<IDNN>("dnn");

export const dnnService = {
  getDnn: dnnAPI.getAll,
  createDnn: dnnAPI.create,
  updateDnn: dnnAPI.update,
  deleteDnn: dnnAPI.delete,
};
